import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = imgUrl
  })
}

function formatearFecha(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
  return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(fecha))
}

// function campo(doc, label, value, x, y, width = 70) {
//   doc.setFontSize(8)
//   doc.setFont('helvetica', 'normal')
//   doc.text(label, x, y)
//   doc.setFontSize(9) 

//   doc.setFont('helvetica', 'bold')
//   doc.text(value || '', x, y + 4)

//   doc.setDrawColor(0)
//   doc.line(x, y + 5, x + width, y + 5)
// }
function campo(doc, label, value, x, y, width = 70, minHeight = 10) {
  doc.setFontSize(7)
  doc.setTextColor('000')
  doc.setFont('helvetica', 'bold')
  doc.text(label, x, y)

  // Texto
  doc.setFontSize(8)
  doc.setTextColor(78, 78, 78)
  doc.setFont('helvetica', 'normal')

  const text = value || ''
  const textLines = doc.splitTextToSize(text, width - 4)
  const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

  // Caja gris SIN borde
  doc.setFillColor(245, 245, 245)
  doc.rect(x, y + 1, width, boxHeight, 'F')

  doc.text(textLines, x + 1, y + 5)
  doc.setDrawColor(208, 208, 208)  
  doc.setLineWidth(0.3)
  doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

  return y + boxHeight + 6
}

function tituloSeccion(doc, texto, y) {
  const pageWidth = doc.internal.pageSize.getWidth()

  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)

  doc.text(texto.toUpperCase(), 15, y)

  doc.setDrawColor(7, 88, 144)
  doc.setLineWidth(0.4)
  doc.line(15, y + 2, 200, y + 2)

  return y + 8
}

async function generarFichaSocioeconomica(paciente, estudio, escalas, firma) {
  const doc = new jsPDF('p', 'mm', 'letter')
  const pageWidth = doc.internal.pageSize.getWidth()


  const logo1 = await getBase64FromImage(logoIzquierdo)
  const logo2 = await getBase64FromImage(logoDerecho)

   // Logo izquierdo
   doc.addImage(logo1, 'PNG', 14, 5, 45, 30)

   // Logo derecho
   doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

   doc.setFontSize(12)
   doc.setFont('helvetica', 'bold')
   doc.text('FICHA SOCIOECONOMICA INICIAL', pageWidth / 2, 15, { align: 'center' })

  // FECHA DE ATENCION
  doc.setTextColor(0)
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(9)
  doc.text('Fecha y hora de atención:' , pageWidth / 2, 20, { align: 'center' })
  doc.setFont('helvetica', 'normal')
  doc.text( formatearFecha(estudio.fechaCreacion), pageWidth / 2, 24, { align: 'center' })
  doc.setFont('helvetica', 'bold')
  doc.text('Fecha y hora de generación:'  ,pageWidth / 2, 28, { align: 'center' })
  doc.setFont('helvetica', 'normal')
  doc.text(formatearFechaHora(new Date),pageWidth / 2, 32, { align: 'center' })


  let y = 45
  y = tituloSeccion(doc, 'DATOS GENERALES DEL PACIENTEL', y)
  campo(doc, 'Folio:', '021001010', 15, y, 50, 5)

  y += 12

  campo(doc, 'Nombre:', paciente.nombres + ' ' + paciente.apellidoPaterno + ' ' + paciente.apellidoMaterno, 15, y, 185, 5)

  y += 12
  campo(doc, 'Fecha de nacimiento:', formatearFecha(paciente.fechaNacimiento), 15, y, 55, 5)
  campo(doc, 'Sexo:', estudio.sexo, 75, y, 65, 5)
  campo(doc, 'Estado civil:', estudio.estadoCivil, 145, y, 55, 5)

  y += 12
  campo(doc, 'Escolaridad:', estudio.escolaridad, 15, y, 185, 5)

  y += 12
  campo(doc, 'Ocupación:', estudio.ocupacion, 15, y, 90, 5)
  campo(doc, 'Religión:', estudio.religion, 110, y, 90, 5)

  y += 12
  campo(doc, 'Originario de:', estudio.originario, 15, y, 185, 5)

  y += 12
  campo(doc, 'Derechohabiente de:', estudio.derechohabiente, 15, y, 185, 5)

  y += 12
  campo(doc, 'Domicilio permanente:', estudio.domicilioPermanente, 15, y, 185, 5)

  y += 12
  campo(doc, 'Domicilio temporal:', estudio.domicilioTemporal, 15, y, 185, 5)

  y += 12
  campo(doc, 'Nombre del familiar o del responsable:', estudio.nombreFamiliarResponsable, 15, y, 185, 5)

  y += 12
  y = campo(doc, 'Diagnóstico Médico: ', estudio.diagnosticoMedico, 15, y, 185, 5)

  const startY = y
  const columnWidth = 90
  const gap = 6

  let grupoFammiliarData = [estudio.grupoFamiliar]

  autoTable(doc, {
    startY,
    margin: { left: 15 },
    tableWidth: columnWidth,
    head: [['Grupo familiar', 'Calificación']],
    body: grupoFammiliarData.map(i => [i.nombre, i.calificacion]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  // TABLA OCUPACIÓN
  let ocupacionData = [estudio.tocupacion]
  const secondColumnX = 15 + columnWidth + gap

  autoTable(doc, {
    startY,
    margin: { left: secondColumnX },
    tableWidth: columnWidth,
    head: [['Ocupación', 'Calificación']],
    body: ocupacionData.map(i => [i.nombre, i.calificacion]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  y = doc.lastAutoTable.finalY + 12

  doc.addPage()
  y = 20

  y = tituloSeccion(doc, 'SISTEMA DE CUOTAS DE RECUPERACIÓN (NIVEL NACIONAL)', y)

  // TABLA DE INGRESOS MENSUALES
  let ingresos = [
    { ingreso: 'Jefe de Familia', calif: estudio.ingresoFamiliar.jefeDeFamilia },
    { ingreso: 'Esposo (a)', calif: estudio.ingresoFamiliar.esposo },
    { ingreso: 'Hijo (a)', calif:  estudio.ingresoFamiliar.hijo },
    { ingreso: 'Otro', calif:  estudio.ingresoFamiliar.otro },
    { ingreso: 'Total', calif: 0 },
  ]

  // TABLA DE EGRESOS MENSUALES 
  let egresos = [
    { egreso: 'Alimentación', calif: estudio.egresoFamiliar.alimentacion },
    { egreso: 'Renta o Predio', calif: estudio.egresoFamiliar.rentaoPredio },
    { egreso: 'Agua', calif: estudio.egresoFamiliar.agua },
    { egreso: 'Luz', calif: estudio.egresoFamiliar.luz },
    { egreso: 'Combustible', calif: estudio.egresoFamiliar.combustible },
    { egreso: 'Transporte', calif: estudio.egresoFamiliar.transporte },
    { egreso: 'Educación', calif: estudio.egresoFamiliar.educacion },
    { egreso: 'Consumos Adicionales', calif: estudio.egresoFamiliar.consumosAdicionales },
    { egreso: 'Total', calif: 0 },
  ]

  const startYTabla = y

  autoTable(doc, {
    startY: startYTabla,
    margin: { left: 15 },
    tableWidth: columnWidth,
    head: [['Ingreso Familiar (Promedio mensual)', 'Calificación']],
    body: ingresos.map(i => [i.ingreso, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYIngresos = doc.lastAutoTable.finalY
  const columnWidth2 = 90
  const secondColumnX2 = 15 + columnWidth2 + gap

  autoTable(doc, {
    startY: startYTabla,
    margin: { left: secondColumnX2 },
    tableWidth: columnWidth2,
    head: [['Egreso Familiar (Promedio mensual)', 'Calificación']],
    body: egresos.map(i => [i.egreso, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYEgresos = doc.lastAutoTable.finalY + 7

  // TABLA DE SALARIO MINIMO
  let salario = [
    { label: estudio.salario.nombre, calif: estudio.salario.calificacion },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let situacion = [
    { label: estudio.situacionEconomica.nombre, calif: estudio.situacionEconomica.calificacion},
  ]

  autoTable(doc, {
    startY: finalYEgresos,
    margin: { left: 15 },
    tableWidth: columnWidth,
    head: [['Salario', 'Calificación']],
    body: salario.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth3 = 90
  const secondColumnX3 = 15 + columnWidth3 + gap

  autoTable(doc, {
    startY: finalYEgresos,
    margin: { left: secondColumnX3 },
    tableWidth: columnWidth3,
    head: [['Situación Económica', 'Calificación']],
    body: situacion.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYEconomia = doc.lastAutoTable.finalY + 7

  // TABLA DE SALARIO MINIMO
  let vivienda = [
    { label: estudio.tipoVivienda.nombre, calif: estudio.tipoVivienda.calificacion },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let dormitorios = [
    { label: estudio.numeroDormitorios.nombre, calif: estudio.numeroDormitorios.calificacion },
  ]


  autoTable(doc, {
    startY: finalYEconomia,
    margin: { left: 15 },
    tableWidth: columnWidth,
    head: [['Tipo de Vivienda', 'Calificación']],
    body: vivienda.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth4 = 90
  const secondColumnX4 = 15 + columnWidth4 + gap

  autoTable(doc, {
    startY: finalYEconomia,
    margin: { left: secondColumnX4 },
    tableWidth: columnWidth4,
    head: [['Número de Dormitorios', 'Calificación']],
    body: dormitorios.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYVivienda = doc.lastAutoTable.finalY + 7

  y = finalYVivienda
  y = campo(doc, 'Diagnóstico Social:', '', 15, y, 185, 5)

  const startYCalificaciones = y

  let sumapuntos = estudio.grupoFamiliar.calificacion +
  estudio.tocupacion.calificacion +
  estudio.salario.calificacion +
  estudio.situacionEconomica.calificacion +
  estudio.tipoVivienda.calificacion + estudio.numeroDormitorios.calificacion
  // TABLA DE SALARIO MINIMO
  let calificaciones = [
    { label: 'Grupo Familiar', calif:  estudio.grupoFamiliar.calificacion },
    { label: 'Ocupación', calif: estudio.tocupacion.calificacion },
    { label: 'Salario', calif: estudio.salario.calificacion },
    { label: 'Situación Económica', calif:estudio.situacionEconomica.calificacion },
    { label: 'Tipo de Vivienda', calif:estudio.tipoVivienda.calificacion },
    { label: 'Número de Dormitorios', calif:estudio.numeroDormitorios.calificacion},
    { label: 'Total de Puntos', calif: sumapuntos },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let escala = [
    { label: escalas, calif: escalas },
  ]

  autoTable(doc, {
    startY: startYCalificaciones,
    margin: { left: 15 },
    tableWidth: columnWidth,
    head: [[
      { content: 'Calificación', colSpan: 2 }
    ]],
    body: calificaciones.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth5 = 90
  const secondColumnX5 = 15 + columnWidth5 + gap

  autoTable(doc, {
    startY: startYCalificaciones,
    margin: { left: secondColumnX5 },
    tableWidth: columnWidth5,
    head: [[
      { content: 'Escala de Clasificación', colSpan: 2 }
    ]],
    body: escala.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })


  const lineaY = doc.lastAutoTable.finalY + 40
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)

  doc.line(pageWidth / 2 - 30, lineaY + 25, pageWidth / 2 + 30, lineaY + 25)
  doc.text(formatMayusculas(''), pageWidth / 2, lineaY + 30, { align: 'center' })
  doc.text('NOMBRE Y FIRMA DEL ENFERMERO', pageWidth / 2, lineaY + 35, { align: 'center' })

  // if (y + 40 > doc.internal.pageSize.height) {
  //   doc.addPage()
  //   y = 20
  // }

  // doc.save('Ficha_Socioeconomica_Inicial.pdf')
  const base64 = doc.output('datauristring')
    return base64
}
export { generarFichaSocioeconomica }